/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_AboutInputs */

const en_header_about = /** @type {(inputs: Header_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Header_AboutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_about = /** @type {((inputs?: Header_AboutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_AboutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_about(inputs)
});